import { useAtomValue, useSetAtom } from 'jotai';
import { activeConversationIdAtom, activeTabNameAtom } from 'components/inbox/store';
import { useQueryClient } from 'react-query';
import { bookingActionDoneAtom } from 'components/booking/atoms';

export const useOnSuccessActionModal = () => {
  const setBookingActionDone = useSetAtom(bookingActionDoneAtom);
  const activeConversationId = useAtomValue(activeConversationIdAtom);
  const activeTabName = useAtomValue(activeTabNameAtom);
  const queryClient = useQueryClient();

  return (markBookingActionDone = true) => {
    queryClient.invalidateQueries(['conversationDetail', activeConversationId]);
    queryClient.invalidateQueries(['conversationsTab', activeTabName]);
    if (markBookingActionDone) setBookingActionDone(true);
  };
};
